export default {
  getDadosRelatorio: state => state.dadosRelatorio,
  getDadosChamada: state => state.dadosChamada,
  getDescriptionSpecificConferencia: state => id => state.conferencias.find(conferencia => conferencia._id === id),
}
